import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Box, useMediaQuery, useTheme } from '@mui/material';

import MultiColorPicker from '~/components/atoms/color-picker/MultiColorPicker';
import TemplateSlider from '~/components/atoms/template-preview/TemplateSlider';
import Accordion from '~/components/ui/Accordion/Accordion';
import Select from '~/components/ui/Select';
import { DESKTOP_MIN_WIDTH, FONTS } from '~/constants/common';
import { PDFBuilderColors } from '~/constants/pdf';
import { useAppDispatch } from '~/hooks/useRedux';
import CreateQRContentBlockLayout from '~/pages/CreateQR/components/CreateQRContentBlockLayout/CreateQRContentBlockLayout';
import { pdfSlice, updatePdfThunk } from '~/store/reducers/previewScreens/pdf';
import { getPdfReducer } from '~/store/reducers/previewScreens/pdf/selectors';

import { templatesImages } from '../utils';

const { actions } = pdfSlice;

export default function Appearance() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const theme = useTheme();

  const isDesktop = useMediaQuery(theme.breakpoints.up(DESKTOP_MIN_WIDTH));
  const { selectedTemplate, fonts, micrositeData, bacgkroundColor } = useSelector(getPdfReducer);

  const getReplacedInitialColor = () => {
    if (bacgkroundColor) return bacgkroundColor;

    return PDFBuilderColors[selectedTemplate];
  };

  const setColorValues = (val) => {
    if (micrositeData?.id) {
      dispatch(
        updatePdfThunk({
          design: {
            primary: val[0],
            secondary: val[1],
          },
        }),
      );
      dispatch(actions.setBackgroundColor(val));
    }
  };

  const handleSendField = (field, value) => {
    dispatch(updatePdfThunk({ [field]: value }));
  };

  return (
    <CreateQRContentBlockLayout type="appearance">
      <Accordion
        defaultExpanded
        variant="child"
        summary={t('basicTemplateLabels:tmplPreview')}
        details={
          <TemplateSlider
            defaultSelectedItem={selectedTemplate}
            selectSlide={(val) => dispatch(actions.setSelectedTemplate(val))}
            images={templatesImages}
          />
        }
      />
      <Accordion
        defaultExpanded
        variant="child"
        summary={t('basicTemplateLabels:tmplDesign')}
        details={
          <MultiColorPicker
            initialColors={PDFBuilderColors}
            selectedTemplate={selectedTemplate}
            selectedColors={[micrositeData?.design?.primary, micrositeData?.design?.secondary]}
            getReplacedInitialColor={getReplacedInitialColor}
            onSketchPickerChange={(val) => dispatch(actions.setBackgroundColor(val))}
            setColorValues={setColorValues}
            blurFunction={(arr) => setColorValues(arr)}
          />
        }
      />
      <Accordion
        defaultExpanded
        variant="child"
        hideBottomBorder
        summary={t('basicTemplateLabels:tmplFonts')}
        details={
          <Box display="flex" flexDirection={isDesktop ? 'row' : 'column'} sx={{ gap: '16px' }}>
            <Select
              items={FONTS}
              onChange={(e) => dispatch(actions.setFonts({ field: 'head', value: e.target.value }))}
              onBlur={() =>
                handleSendField('fonts', {
                  title_font: fonts.head,
                  text_font: fonts.text,
                })
              }
              fullWidth
              label={t('other:title')}
              value={fonts?.head || FONTS[3].value}
            />
            <Select
              items={FONTS}
              onChange={(e) => dispatch(actions.setFonts({ field: 'text', value: e.target.value }))}
              onBlur={() =>
                handleSendField('fonts', {
                  title_font: fonts.head,
                  text_font: fonts.text,
                })
              }
              fullWidth
              label={t('other:text')}
              value={fonts?.text || FONTS[3].value}
            />
          </Box>
        }
      />
    </CreateQRContentBlockLayout>
  );
}
